module.exports = __webpack_public_path__ + "img/20220709_KSAF_AGH_AGHSolarBoatMonacoEnergyBoatChallenge_KSadowy_013.d77b07d6.webp";